import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUp, Paperclip, Mic } from 'lucide-react';

const REPLY = 'Latency held at a 42 ms median across all regions. One regression flagged: eu-west p99 rose 18% after the 14 Oct deploy — likely cache warm-up. I\'ve drafted a rollback plan and a summary for the team.';

const ChatMockup = () => {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    let i = 0;
    const start = setTimeout(() => {
      const id = setInterval(() => {
        i += 2;
        setTyped(REPLY.slice(0, i));
        if (i >= REPLY.length) clearInterval(id);
      }, 18);
    }, 1200);
    return () => clearTimeout(start);
  }, []);

  const done = typed.length >= REPLY.length;

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="relative mt-20 lg:mt-28"
      data-testid="hero-abstract-chat-mockup"
    >
      <div className="relative rounded-xl border border-line bg-surface overflow-hidden shadow-[0_40px_120px_-40px_rgba(0,0,0,0.5)]">
        <div className="flex items-center justify-between px-5 py-3 border-b border-line">
          <div className="flex items-center gap-3">
            <div className="flex gap-1.5">
              {[0, 1, 2].map(i => <span key={i} className="w-2 h-2 rounded-full bg-line-2" />)}
            </div>
            <span className="text-[11px] font-mono text-content-3 ml-2">opensov.com/chat</span>
          </div>
          <div className="hidden sm:flex items-center gap-2 text-[11px] font-mono text-content-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" />
            opensov-1 · streaming
          </div>
        </div>

        <div className="px-6 sm:px-10 lg:px-16 py-10 lg:py-12 max-w-3xl mx-auto">
          <div className="flex justify-end">
            <p className="max-w-[80%] bg-overlay-strong text-content text-sm sm:text-[15px] leading-relaxed rounded-2xl rounded-tr-sm px-5 py-3">
              Summarize our Q3 latency report and flag any regressions.
            </p>
          </div>
          <div className="flex gap-4 mt-8 min-h-[96px]">
            <div className="w-7 h-7 rounded-full border border-line flex-shrink-0 flex items-center justify-center mt-0.5">
              <span className="w-2 h-2 rounded-full bg-[#10B981]" />
            </div>
            <p className="text-content-2 text-sm sm:text-[15px] leading-relaxed pt-1">
              {typed}
              {!done && <span className="inline-block w-[2px] h-4 ml-0.5 align-middle bg-content animate-pulse" />}
            </p>
          </div>

          <div className="mt-10 flex items-center gap-3 border border-line-2 rounded-full pl-5 pr-2 py-2 bg-app">
            <span className="flex-1 text-sm text-content-3">Ask anything…</span>
            <Paperclip className="w-4 h-4 text-content-3" strokeWidth={1.5} />
            <Mic className="w-4 h-4 text-content-3" strokeWidth={1.5} />
            <span className="w-8 h-8 rounded-full bg-btn text-btn-foreground flex items-center justify-center">
              <ArrowUp className="w-4 h-4" strokeWidth={2} />
            </span>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2 px-6 py-3 border-t border-line text-[11px] font-mono text-content-3">
          <span>TTFT <span className="text-content">42ms</span></span>
          <span>Throughput <span className="text-content">78 tok/s</span></span>
          <span>Retention <span className="text-content">Zero</span></span>
          <span>Region <span className="text-content">Sovereign cloud</span></span>
        </div>
      </div>
    </motion.div>
  );
};

export default ChatMockup;
